import StoryEvgenia from './StoryEvgenia';
export default StoryEvgenia;